<template>
  <div class="navbar">
    <el-row>
      <el-col :span="8">
        <div style="float:left;overflow:hidden">
          <img src="@/assets/user_images/jdLogo.png" alt="" class="nav-logo" style="height: 40px;" height="40">
        </div>
      </el-col>
      <el-col :span="8" style="color:#fff">
        <!-- <el-menu class="el-menu-demo" mode="horizontal" menu-trigger="hover">
          <template v-for="(items,idx) in base">
            <el-submenu :class="currentPath==items.path?'active':'' " v-if="items.children&& items.isShow"
              :index="items.path">
              <template v-if="items.isShow" slot="title">{{items.title}}</template>
              <template v-if="items.isShow" v-for="item in items.children">
                <router-link :to="{ path: item.path }">
                  <el-menu-item :index="item.path">
                    {{item.title}}
                  </el-menu-item>
                </router-link>
              </template>
            </el-submenu> -->
            <router-link to="/launchList">
                首页
              </router-link>
          <!-- </template>
        </el-menu> -->
      </el-col>
      <el-col :span="8">
        <div class="right-menu">
          <div class="avatar-wrapper">
            <img src="@/assets/user_images/默认头像@1x.png" class="user-img">
          </div>
          <!-- <a href="javascript:;" class="color-108cee font-size-12 mr20" @click="clickLogout">退出</a> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'
  import { clearToken } from '@/utils/auth'
  import { getStroage, removeStroage } from "@/utils/auth"
  import Setting from '../../settings'
  const {
    workBenchDomain
  } = Setting
  export default {
    components: {
      Breadcrumb,
      Hamburger
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'avatar'
      ])
    },
    data() {
      return {
        name: null,
        activeIndex: '1',
        currentPath: '/',
        base: [],
        name: null

      }
    },
    created() {
      // this.getUserInfo()
    },
    mounted() {
      this.initStyle()

    },
    methods: {
      initStyle() {
        this.base = [{
  "children": [{
    "children": null,
    "component": "launchList/index",
    "menuType": 4,
    "meta": {
      "icon": "search10_1",
      "title": "流量主区间列表"
    },
    "name": "流量主区间列表",
    "path": "/test",
    "redirect": "",
    "title": "流量主区间列表"
  },],
  "component": "Layout",
  "menuType": 3,
  "meta": {
    "icon": "search10_0",
    "title": "综合查询"
  },
  "name": "综合查询",
  "path": "/launchList",
  "redirect": "Layout",
  "title": "综合查询"
}, {
  "children": [{
    "children": null,
    "component": "billManagement/index",
    "menuType": 4,
    "meta": {
      "icon": "report9_3",
      "title": "数据包金额统计"
    },
    "name": "数据包金额统计",
    "path": "//bill",
    "redirect": "",
    "title": "数据包金额统计"
  }],
  "component": "Layout",
  "menuType": 3,
  "meta": {
    "icon": "report9_0",
    "title": "统计报表"
  },
  "name": "统计报表",
  "path": "/report",
  "redirect": "Layout",
  "title": "统计报表"
}]

        this.currentPath = this.base[0].redirect

      },
      watchNav(_path) {
        this.currentPath = _path
      },
      toggleSideBar() {
        this.$store.dispatch('app/toggleSideBar')
      },


      handleSelect(key, keyPath) {
        // console.log(key, keyPath)
      }

    }
  }
</script>

<style lang="scss" scoped>
  .quit {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.85);
    cursor: pointer;
  }

  .quit:hover {
    color: #fff
  }

  .el-dropdown-menu__item {
    height: 44px;
    color: rgba(0, 0, 0, 0.65);
  }

  .el-dropdown-menu__item--divided {
    border-top: none;
    margin-top: 0;
  }

  .navbar .right-menu .avatar-container .avatar-wrapper .el-icon-arrow-down[data-v-d16d6306] {
    top: 23px;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #fff;
    color: #ffa940;

  }

  .el-dropdown-menu {
    top: 48px !important;
    // left:224px !important;
  }

  .el-dropdown {
    color: #fff;
    margin-right: 56px;
    font-size: 14px;
  }

  .el-popper .popper__arrow {
    display: none !important;
  }

  .logo {
    margin-left: 24px;
    margin-top: 5px;
  }

  .name {
    font-size: 12px;
    color: #fff;
    margin-right: 8px;
  }

  .user-img {
    top: 10px;
    position: relative;
  }

  .border {
    display: inline-block;
    border: 1px solid rgba(255, 255, 255, 0.5);
    height: 24px;
    position: relative;
    margin-right: 8px;
    margin-left: 8px;
    top: -2px;
  }

  .title {
    font-size: 16px;
    color: #fff;
    margin-right: 80px;
  }

  .navbar {
    height: 60px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    .hamburger-container {
      line-height: 46px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .breadcrumb-container {
      float: left;
    }

    .right-menu {
      float: right;
      height: 100%;
      line-height: 50px;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background 0.3s;

          &:hover {
            background: rgba(0, 0, 0, 0.025);
          }
        }
      }

      .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {
          margin-top: 5px;
          position: relative;

          .user-avatar {
            cursor: pointer;
            // width: 40px;
            // height: 40px;
            position: relative;
            top: 6px;
            border-radius: 10px;
          }

          .el-icon-arrow-down {
            cursor: pointer;
            position: absolute;
            right: -9px;
            top: 23px;
            font-size: 12px;
          }
        }
      }
    }
  }

  body .app-wrapper-new-style .navbar {
    height: 60px;
    box-sizing: border-box;
    padding: 0px 24px;
    line-height: 60px;
  }

  .el-menu.el-menu--horizontal {
    float: left;
  }

  .el-menu {
    background-color: #ffa940;
  }

  body .el-menu {
    top: 0px !important;
  }
</style>
